import React, { useState } from 'react';
import ButtonOptions from '../../../../../../components/NovoSistema/ButtonOptions';
import ButtonsGeneric from '../../../../../../components/NovoSistema/ButtonsGeneric';
import { ContainerSection } from '../../../../../../components/NovoSistema/ContainerSection';
import DoubleInput from '../../../../../../components/NovoSistema/DoubleInput';
import HeaderButtons from '../../../../../../components/NovoSistema/HeaderButtons';
import InputCheckBox from '../../../../../../components/NovoSistema/InputCheckBox';
import InputDate from '../../../../../../components/NovoSistema/InputDate';
import InputText from '../../../../../../components/NovoSistema/InputText';
import Legends from '../../../../../../components/NovoSistema/Legends';
import SelectAndOptions from '../../../../../../components/NovoSistema/SelectAndOptions';
import { WrapperInputsNewSystem } from '../../../../../../components/NovoSistema/WrapperInputsNewSystem';
import { WrapperLegendItens } from '../../../../../../components/NovoSistema/WrapperLegendItens';

export default function CadEmpresaN1Add({ setOption }) {
  const [internalOption, setInternalOption] = useState('Empresa');
  return (
    <div>
      <HeaderButtons>
        <ButtonOptions
          buttonName="Empresa"
          border="#333F50"
          active={internalOption === 'Empresa' ? true : false}
          yourFunction={() => setInternalOption('Empresa')}
        />
        <ButtonOptions
          buttonName="Endereço"
          border="#333F50"
          active={internalOption === 'Endereço' ? true : false}
          yourFunction={() => setInternalOption('Endereço')}
        />
        <ButtonOptions
          buttonName="Insc. do Sub Tributário"
          border="#333F50"
          active={internalOption === 'Insc. do Sub Tributário' ? true : false}
          yourFunction={() => setInternalOption('Insc. do Sub Tributário')}
        />
        <ButtonOptions
          buttonName="Âmbito Federal"
          border="#333F50"
          active={internalOption === 'Âmbito Federal' ? true : false}
          yourFunction={() => setInternalOption('Âmbito Federal')}
        />
        <ButtonOptions
          buttonName="Simples Nacional"
          border="#333F50"
          active={internalOption === 'Simples Nacional' ? true : false}
          yourFunction={() => setInternalOption('Simples Nacional')}
        />
        <ButtonOptions
          buttonName="Logotipo"
          border="#333F50"
          active={internalOption === 'Logotipo' ? true : false}
          yourFunction={() => setInternalOption('Logotipo')}
        />
        <ButtonOptions
          buttonName="Conta"
          border="#333F50"
          active={internalOption === 'Conta' ? true : false}
          yourFunction={() => setInternalOption('Conta')}
        />
        <ButtonOptions
          buttonName="Credencial"
          border="#333F50"
          active={internalOption === 'Credencial' ? true : false}
          yourFunction={() => setInternalOption('Credencial')}
        />
      </HeaderButtons>
      {internalOption === 'Empresa' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Número" id="Numero" widthPercentage="20%" />
                <InputText title="Situação" id="Situacao" widthPercentage="20%" />
                <Legends itens={[{ text: 'Não Sincronizado', color: 'red' }]} />
                <DoubleInput title="Grupo de Empresa" id="GrupoDeEmpresa" widthPercentage="40%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="* Nome/Razão Social" id="NomeRazaoSocial" widthPercentage="40%" />
                <InputText title="* Nome Fantasia" id="NomeFantasia" widthPercentage="40%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Tipo de Pessoa"
                  id="TipoDePessoa"
                  optionsArray={['', 'Física', 'Jurídica']}
                  widthPercentage="20%"
                />
                <InputText title="* CNPJ/CPF" id="CNPJ/CPF" widthPercentage="20%" />
                <InputText title="* Inscrição Estadual" id="InscricaoEstadual" widthPercentage="20%" />
                <InputCheckBox title="Isento" id="Isento" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Tipo de Empresa"
                  id="TipoDeEmpresa"
                  optionsArray={[
                    '',
                    'Comércio',
                    'Serviços',
                    'Equiparado a Indústria',
                    'Indústria',
                    'Comércio c/ Registradora',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="Inscrição Municipal" id="InscricaoMunicipal" widthPercentage="20%" />
                <InputText title="CEI" id="CEI" widthPercentage="20%" />
                <InputText title="Suframa" id="Suframa" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="CNAE" id="CNAE" widthPercentage="20%" />
                <InputText title="CNAE Preponderante" id="CNAEPreponderante" widthPercentage="20%" />
                <InputText title="Natureza Jurídica" id="NaturezaJuridica" widthPercentage="20%" />
                <InputText title="Nº Registro" id="NRegistro" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Telefone" id="Telefone" widthPercentage="20%" />
                <InputText title="Fax" id="Fax" widthPercentage="20%" />
                <SelectAndOptions
                  title="Ramo de Atividade"
                  id="RamoDeAtividade"
                  optionsArray={[
                    '',
                    'Academia de Esportes',
                    'Agricultura / Pecuária',
                    'Calçados',
                    'Eletrônicos',
                    'Jurídico',
                    'Saúde',
                    'Segurança',
                    'Outros',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="Especifique" id="Especifique" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Site" id="Site" widthPercentage="40%" />
                <InputText title="E-mail" id="E-mail" widthPercentage="40%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Horário de Fechamento" id="HorarioDeFechamento" widthPercentage="40%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Endereço' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Tipo Endereço"
                  id="TipoEndereco"
                  optionsArray={['', 'Principal', 'Entrega', 'Cobrança']}
                  widthPercentage="40%"
                />
                <InputText title="* CEP" id="CEP" widthPercentage="40%" />
                <ButtonsGeneric>
                  <button className="success">Pesquisar</button>
                </ButtonsGeneric>
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Tipo Logradouro"
                  id="TipoLogradouro"
                  optionsArray={[
                    '',
                    'Rua',
                    'Aeroporto',
                    'Avenida',
                    'Campo',
                    'Condomínio',
                    'Distrito',
                    'Núcleo',
                    'Pátio',
                    'Praça',
                    'Quadra',
                    'Residencial',
                    'Via',
                    'Outro',
                  ]}
                  widthPercentage="20%"
                />
                <InputText title="* Logradouro" id="Logradouro" widthPercentage="20%" />
                <InputText title="* Número" id="Numero" widthPercentage="20%" />
                <InputText title="* Bairro" id="Bairro" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="Complemento" id="Complemento" widthPercentage="20%" />
                <SelectAndOptions
                  title="* País"
                  id="Pais"
                  optionsArray={['', 'BRASIL', 'EUA', 'CANADA', 'CHINA', 'RUSSIA', 'ESPANHA', 'JAPÃO', 'KOREIA DO SUL']}
                  widthPercentage="20%"
                />
                <SelectAndOptions
                  title="* UF"
                  id="UF"
                  optionsArray={[
                    '',
                    'AC',
                    'AL',
                    'AP',
                    'AM',
                    'BA',
                    'CE',
                    'DF',
                    'ES',
                    'GO',
                    'MA',
                    'MT',
                    'MS',
                    'MG',
                    'PA',
                    'PB',
                    'PR',
                    'PE',
                    'PI',
                    'RJ',
                    'RN',
                    'RS',
                    'RO',
                    'RR',
                    'SC',
                    'SP',
                    'SE',
                    'TO',
                  ]}
                  widthPercentage="20%"
                />
                <SelectAndOptions
                  title="* Município"
                  id="Municipio"
                  optionsArray={['', 'Outros']}
                  widthPercentage="20%"
                />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">Mapa</button>
                <button className="success">+ Adicionar</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Insc. do Sub Tributário' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="I.E (Subst Trib.) UF"
                  id="IESubstTribUF"
                  optionsArray={[
                    '',
                    'AC',
                    'AL',
                    'AP',
                    'AM',
                    'BA',
                    'CE',
                    'DF',
                    'ES',
                    'GO',
                    'MA',
                    'MT',
                    'MS',
                    'MG',
                    'PA',
                    'PB',
                    'PR',
                    'PE',
                    'PI',
                    'RJ',
                    'RN',
                    'RS',
                    'RO',
                    'RR',
                    'SC',
                    'SP',
                    'SE',
                    'TO',
                  ]}
                  widthPercentage="40%"
                />
                <InputText title="I.E. (Subst Trib.)" id="IESubstTrib" widthPercentage="40%" />
                <ButtonsGeneric>
                  <button className="success">+ Adicionar</button>
                </ButtonsGeneric>
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Âmbito Federal' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="* Enquadramento Tributário"
                  id="EnquadramentoTributario"
                  optionsArray={[
                    '',
                    'Lucro Real',
                    'Lucro Presumido',
                    'Lucro Presumido EPP',
                    'Lucro Nacional ME',
                    'Lucro Nacional EPP',
                    'Lucro Nacional ME - Excesso sublimite de receita bruta',
                    'Lucro Nacional EPP - Excesso sublimite de receita bruta',
                  ]}
                  widthPercentage="40%"
                />
                <SelectAndOptions
                  title="Fechamento do Balanço"
                  id="FechamentoDoBalanco"
                  optionsArray={['', 'Mensal', 'Anual']}
                  widthPercentage="40%"
                />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <SelectAndOptions
                  title="Enquadramento MP66 PIS COFINS"
                  id="EnquadramentoMP66PISCOFINS"
                  optionsArray={['', 'Enquadrado', 'Não Enquadrado']}
                  widthPercentage="40%"
                />
                <SelectAndOptions
                  title="SPED"
                  id="SPED"
                  optionsArray={['', 'Enquadrado', 'Não Enquadrado']}
                  widthPercentage="20%"
                />
                <InputDate title="Data de Enquadramento" id="DataDeEnquadramento" widthPercentage="20%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Simples Nacional' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputCheckBox title="Empresa exibe Tributos na NF" id="EmpresaExibeTributosNaNF" />
                <InputText title="Período" id="Periodo" widthPercentage="20%" />
                <InputText title="Alíquota ICMS" id="AliquotaICMS" widthPercentage="20%" />
                <InputText title="Alíquota ISS" id="AliquotaISS" widthPercentage="20%" />
                <ButtonsGeneric>
                  <button className="success">+ Incluir</button>
                </ButtonsGeneric>
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Logotipo' && (
        <div>
          <ContainerSection>
            <div>
              <h3>Imagem</h3>
              <ButtonsGeneric>
                <button className="success">Arquivo</button>
                <button className="success">Enviar</button>
                <button className="error">Cancelar</button>
                <button className="error">Excluir</button>
              </ButtonsGeneric>
              <WrapperLegendItens>
                <input type="file" name="attachments" id="attachments" />
              </WrapperLegendItens>
            </div>
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Conta' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="Código Cliente" id="CodigoCliente" widthPercentage="20%" />
                <InputText title="Quantidade Sessões" id="QuantidadeSessoes" widthPercentage="20%" />
                <InputText title="CNPJ Principal" id="CNPJprincipal" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <ButtonsGeneric>
                <button className="success">Atualizar Licenças</button>
              </ButtonsGeneric>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Legenda</h3>
            <Legends
              itens={[
                { text: 'Normal', color: 'green' },
                { text: 'Inadimplente', color: 'yellow' },
                { text: 'Cancelado', color: 'red' },
              ]}
            />
          </ContainerSection>
        </div>
      )}

      {internalOption === 'Credencial' && (
        <div>
          <ContainerSection>
            <div>
              <WrapperInputsNewSystem>
                <InputText title="PDV" id="PDV" widthPercentage="20%" />
                <InputText title="NFC-e/SAT" id="NFC-eSAT" widthPercentage="20%" />
                <InputText title="NFC-e/SAT Mobile" id="NFC-eSATMobile" widthPercentage="20%" />
                <InputText title="NFC-e/SAT Totem" id="NFC-eSATTotem" widthPercentage="20%" />
              </WrapperInputsNewSystem>
              <WrapperInputsNewSystem>
                <InputText title="NFC-e/SAT Atendimento" id="NFC-eSATAtendimento" widthPercentage="20%" />
                <InputText title="NFC-e/SAT APP Atendimento" id="NFC-eSATAPPAtendimento" widthPercentage="20%" />
              </WrapperInputsNewSystem>
            </div>
          </ContainerSection>
          <ContainerSection>
            <h3>Legenda</h3>
            <Legends
              itens={[
                { text: 'Ativo', color: 'green' },
                { text: 'Inativo', color: 'red' },
              ]}
            />
          </ContainerSection>
        </div>
      )}
      <ButtonsGeneric>
        <button className="success">Salvar</button>
        <button className="error" onClick={() => setOption('search')}>
          Retornar
        </button>
      </ButtonsGeneric>
      <span> {' * '} Campo de preenchimento Obrigatório</span>
    </div>
  );
}
